import { StateCreator } from "zustand";
import { NavbarProps } from "@/shared/components/layout/Navbar.mobile";
import { FabProps } from "@/shared/components/layout/PageLayout";

export interface PageLayoutSlice {
  pageLayout: {
    // Atomic state slots for performant subscriptions
    navbar?: NavbarProps;
    fab?: FabProps;
    showBottomNavigation: boolean;
    className?: string;
    resizeViewportOnKeyboardOpen?: boolean;
    onScroll?: (event: React.UIEvent<HTMLElement>) => void;
    animationKey?: string;

    // Actions
    set: (
      config: Omit<Partial<PageLayoutSlice["pageLayout"]>, "set" | "reset" | "setNavbar" | "setFab" | "setBottomNav">
    ) => void;
  };
}

const defaultPageLayout = {
  navbar: undefined,
  fab: undefined,
  showBottomNavigation: false,
  className: undefined,
  resizeViewportOnKeyboardOpen: false,
  onScroll: undefined,
  animationKey: undefined,
};

const createPageLayoutSlice: StateCreator<PageLayoutSlice, [], [], PageLayoutSlice> = (set) => ({
  pageLayout: {
    ...defaultPageLayout,

    set: (config) =>
      set((state) => ({
        pageLayout: { ...state.pageLayout, ...defaultPageLayout, ...config },
      })),
  },
});

export default createPageLayoutSlice;
